import { Component, OnInit, ViewChild, ViewContainerRef, ChangeDetectionStrategy } from '@angular/core';
import { AuthApiService, PagesService } from '@digilize/shared/data/services';
import { Company, CompanyMenu, Me } from '@shared/definitions';
import { Subject } from 'rxjs';

@Component({
  selector: 'suc-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DashboardComponent implements OnInit {
  activeCompany: Company;
  companies: Company[] = [];
  loading = true;
  me: Me;
  navigationOpened = false;
  companyMenu: CompanyMenu;
  isAdmin;
  logo$ = this.pagesService.getLogo();
  companiesLoaded: Subject<boolean> = new Subject();
  userMenuOpen;
  navElement: HTMLElement;
  @ViewChild('navigation', { read: ViewContainerRef }) navigation: ViewContainerRef;
  constructor(
    private authApiService: AuthApiService,
    private pagesService: PagesService
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.navElement = this.navigation.element.nativeElement;
    }, 0);
    this.authApiService.me.subscribe((resp) => {
      if (resp) {
        this.me = resp;
      }
    });
  }
}
